export enum SystemEntityUrlSegment {
    Permission = 'permissions',
    Action = 'action',
}
